/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { SprinkrlPlaceholder } from 'components/sprinkrlPlaceholder/SprinkrlPlaceholder';
import type { WidgetPlaceholderFragment } from 'lib/contentful/__generated__/ModuleWidgetPlaceholder';

export type WidgetRendererProps = WidgetPlaceholderFragment;

export const WidgetRenderer = (props: WidgetRendererProps) => {
  const contentTypeId: keyof typeof ContentTypeMap = props?.widget as any;
  const Component = ContentTypeMap[contentTypeId];

  if (!Component) {
    console.warn(`Widget ${contentTypeId} can not be handled`);
    return null;
  }

  return <Component {...props} />;
};

const ContentTypeMap = {
  Sprinkrl: SprinkrlPlaceholder,
};
